/**
 * Portal Manta · AgentesCatalogoPage
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { M, F, STATUS } from '../../tokens/theme.js';
import { AGENTES_CATALOG } from '../../data/agentes-catalog.js';
import { PIPELINES } from '../../data/pipelines.js';
import { CatalogoTabInterno } from './CatalogoTabInterno.jsx';
import { AluciGuardPage } from '../aluci-guard/AluciGuardPage2.jsx';
import { AGENTES_CATEGORIAS } from '../../app-globals.js';

const AgentesCatalogoPage = memo(function AgentesCatalogoPage_Inner(){
  const [aba, setAba] = useState('catalogo');
  return (<div style={{padding:0, fontFamily:F.body}}>
    <div style={{padding:'18px 28px 0'}}>
      <div style={{fontFamily:F.display, fontSize:22, fontWeight:600, color:M.title, marginBottom:6, paddingBottom:8, borderBottom:`2px solid ${M.borderSoft}`, display:'flex', alignItems:'baseline', gap:14}}>
        <span style={{fontFamily:F.mono, fontSize:11, color:'#fff', fontWeight:700, padding:'4px 10px', background:M.accent, letterSpacing:1, flexShrink:0}}>08</span>
        🧠 Catálogo de Agentes
      </div>
      <div style={{fontSize:12.5, color:M.muted, marginBottom:14}}>
        {Object.keys(AGENTES_CATALOG).length} agentes em {Object.keys(AGENTES_CATEGORIAS).length} categorias · {Object.keys(PIPELINES).length} pipelines · Camada Skills/Agentes (PK_07 · 02.4)
      </div>
      {/* Sub-abas */}
      <div style={{display:'flex', gap:0, marginBottom:0, background:'#fff', border:`1px solid ${M.border}`, borderRadius:'6px 6px 0 0', overflow:'hidden'}}>
        {[
          {k:'catalogo', n:'08.1', l:'Catálogo & Pipelines', ic:'📋'},
          {k:'aluci',    n:'08.2', l:'aluci-guard · Pacote A', ic:'🛡️'},
        ].map(t=>(
          <button key={t.k} onClick={()=>setAba(t.k)} style={{
            flex:1, padding:'10px 16px', fontSize:11.5, fontWeight:700,
            background:aba===t.k?M.accent:'transparent', color:aba===t.k?'#fff':M.text,
            border:'none', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:8,
            fontFamily:F.body,
          }}>
            <span style={{fontFamily:F.mono, fontSize:9.5, opacity:0.8}}>{t.n}</span>
            <span style={{fontSize:14}}>{t.ic}</span>
            <span>{t.l}</span>
          </button>
        ))}
      </div>
    </div>
    <div style={{borderTop:'none'}}>
      {aba==='catalogo' && <CatalogoTabInterno/>}
      {aba==='aluci' && <AluciGuardPage/>}
    </div>
  </div>);
});

export { AgentesCatalogoPage };
export default AgentesCatalogoPage;
